export enum OrderStatus {
  Pending = 'pending',
  PaymentFailed = 'payment_failed',
  AwaitingApproval = 'awaiting_approval',
  Confirmed = 'confirmed',
  AwaitingShipment = 'awaiting_shipment',
  PartiallyScheduled = 'partially_scheduled',
  ScheduledRequested = 'schedule_requested',
  Shipped = 'shipped',
  PartiallyShipped = 'partially_shipped',
  PartiallyDelivered = 'partially_delivered',
  PartiallyUndelivered = 'partially_undelivered',
  PartiallyReturnToOrigin = 'partially_return_to_origin',
  Completed = 'complete',
  Draft = 'draft',
  Cancelled = 'cancelled',
  Delivered = 'delivered',
}
